import $ from "jquery";
import "@@assets/scripts/_$.addImageRatioInfo";
import { PM_THEME_NAME } from "../_blocksConfig";

$(() => {
	const $block = $(`.wp-block-${PM_THEME_NAME}-slider-with-text`);
	if(!$block.length) {
		return false;
	}
	
	$block.find(".slides").each((i, elm) => {
		const $slides = $(elm);
		$slides.find("img").addImageRatioInfo(!!$slides.children().length && (() => {
			const data = $slides.data();
			
			$slides.slick({
				fade: (data.effect === "fade"),
				autoplay: data.autoplay,
				dots: data.dots,
				arrows: data.arrows,
				speed: data.speed,
				adaptiveHeight: true,
				pauseOnFocus: false,
				cssEase: "linear",
				lazyLoad: "anticipated",
			});
		}));
	});
});
